import { Textarea, Typography } from '@material-tailwind/react';
import MsgInputError from './MsgInputError';
const TextAreaGlobal = ({ text, register, formCamp,errors,validations }) => {
  return (
    <div className="flex flex-col w-[90%] px-5 md:px-0 md:w-[50%]">
      <Typography
        variant="h6"
        color="black"
        className="mb-1 text-left font-medium dark:text-darkText 
         "
      >
        {text}
      </Typography>
      <div className="w-[100%] ">
        <Textarea
          rows={4} 
          className={` 
         ' placeholder:text-gray-500  text-black !border !border-gray-300  focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 '
           placeholder:opacity-100 uppercase  bg-white  `}
          labelProps={{
            className: 'hidden ',
          }}
          {...register(formCamp,validations)}
        />
        {errors && <MsgInputError text={errors[formCamp]?.message} />}
      </div>
    </div>
  );
};

export default TextAreaGlobal;
